import { z } from "zod"

export const opModeSearchSchema = z.object({
	opMode: z.string().catch("all"), // loader makes it required in practice for default="first"
})
